import { render, staticRenderFns } from "./ConsultarDocumento.vue?vue&type=template&id=9ff7420c"
import script from "./ConsultarDocumento.vue?vue&type=script&lang=js"
export * from "./ConsultarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports